import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FacebookCircle from '../../Icons/FacebookCircle';
import LinkedIn from '../../Icons/LinkedIn';
import Instagram from '../../Icons/Instagram';
import Youtube from '../../Icons/Youtube';

import classNames from '../../utils/dom-utils';
import CaretPositioning from './EditCaretPositioning';

class Input extends Component {
  constructor(props) {
    super(props);
    this.val = props.value || '';
    this.state = {
      caretPosition: {
        start: 0,
        end: 0,
      },
    };
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  handlePaste(event) {
    if (event.clipboardData.types.includes('Files')) {
      event.preventDefault();
    }
  }

  onChangeHandler(event) {
    const { name } = this.props;
    const targetValue = event.currentTarget.textContent;
    const savedCaretPosition = CaretPositioning.saveSelection(
      event.currentTarget,
    );
    this.val = targetValue.replace(/^\n|\n$/g, '');
    this.setState(
      {
        caretPosition: savedCaretPosition,
      },
      () => {
        CaretPositioning.restoreSelection(
          document.getElementById(name),
          this.state.caretPosition,
        );
      },
    );

    this.props.onChange(event.currentTarget);
  }

  getServiceIcon(serviceName) {
    switch (serviceName) {
      case 'facebook':
        return <FacebookCircle />;
      case 'linkedin':
        return <LinkedIn />;
      case 'instagram':
        return <Instagram />;
      case 'youtube':
        return <Youtube />;
      default:
        return false;
    }
  }

  render() {
    const {
      characterCount = [],
      errorType = 'none',
      placeholder = 'Text',
      title = '',
      name,
      darkTheme = true,
    } = this.props;

    const baseContainerClass = 'c-input-container';
    const baseClass = 'c-input';
    const baseTitleClass = 'c-input__title';
    const baseCharacterCountClass = 'c-input__character-count';

    const displayValue = this.val;

    const rootClass = classNames(baseClass, {
      [`${baseClass}--${errorType}`]: errorType,
      [`${baseClass}--characterCount`]: characterCount.length > 0,
      [`${baseClass}--dark-mode`]: darkTheme,
    });

    const rootTitleClass = classNames(baseTitleClass, {
      [`${baseTitleClass}--dark-mode`]: darkTheme,
    });

    const rootCharacterCountClass = classNames(baseCharacterCountClass, {
      [`${baseCharacterCountClass}--dark-mode`]: darkTheme,
    });

    let listItems = '';

    if (characterCount) {
      listItems = characterCount
        .sort((a, b) => b.platform.localeCompare(a.platform))
        .map((service) => {
          let characterCountClass = '';

          if (this.val.length > service.max) {
            characterCountClass = classNames({
              [`${baseCharacterCountClass}--${service.errorType}`]: service.errorType,
            });
          }

          return (
            <li
              key={service.platform}
              className={characterCountClass}
            >
              {this.getServiceIcon(service.platform)}
              {service.max - this.val.length}
            </li>
          );
        });
    }

    return (
      <div className={baseContainerClass}>
        {title && <div className={rootTitleClass}>{title}</div>}
        <div className="flex-class">
          <div
            id={name}
            className={rootClass}
            role="textbox"
            type="text"
            contentEditable
            placeholder={placeholder}
            onInput={this.onChangeHandler.bind(this)}
            onKeyDown={this.handleKeyDown.bind(this)}
            onPaste={this.handlePaste.bind(this)}
            suppressContentEditableWarning
            tabIndex={this.props.tabIndex}
            ref={this.props.innerRef}
          >
            {displayValue}
          </div>
          {characterCount.length > 0 && (
          <ul className={rootCharacterCountClass}>{listItems}</ul>
          )}
        </div>
      </div>
    );
  }
}

Input.propTypes = {
  placeholder: PropTypes.string,
  title: PropTypes.string,
  darkTheme: PropTypes.bool,
  characterCount: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  errorType: PropTypes.string,
  name: PropTypes.string.isRequired,
  tabIndex: PropTypes.number,
  innerRef: PropTypes.shape({
    current: PropTypes.instanceOf(HTMLDivElement),
  }),
};

function CustomInput(props, ref) {
  return <Input innerRef={ref} {...props} />;
}
export default React.forwardRef(CustomInput);
